import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ElementRef,
} from "@angular/core";
import { ModalWrapperComponent } from "../../../modals/components/modal-wrapper/modal-wrapper.component";
import { MatDialog } from "@angular/material/dialog";
import { VolvoApiService } from "../../../../services/volvo-api.service";
import { CookieService } from "ngx-cookie-service";
import { PageConfiguration } from "../../../../models/page-configuration";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-callout",
  templateUrl: "./callout.component.html",
  styleUrls: ["./callout.component.scss"],
})
export class CalloutComponent implements OnInit {
  @Input() callout: any;
  @Input() Guid: any;
  @Input() localStrings: any;
  @Input() CountryID: number;
  @Input() AdditionalFieldsFormID: number;
  @Input() pageConfig: PageConfiguration;
  @Input() isHotelPromotion: boolean;
  @Input() promotionAlias: string;

  constructor(
    private dialog: MatDialog,
    private volvoApi: VolvoApiService,
    private elRef: ElementRef,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  onClick() {
    // TODO: only open modal when no url is provided
    if (this.callout.ModalName) {
      const d = this.openModal(this.callout.ModalName);
    }
  }

  openModal(name: string) {
    if (name === "registration" && this.pageConfig.UseIdMe) {
      // try to find the idme code in the cookie
      const idMeCode = this.cookieService.get("idMeCode");
      const idMeInfo = this.cookieService.get("idMeInfo");

      if (idMeCode === "" || idMeInfo === "") {
        const idMeButton: HTMLElement = document.getElementsByClassName(
          "idme-trigger-link"
        )[0] as HTMLElement;

        if (typeof idMeButton !== "undefined") {
          idMeButton.click();
          return;
        }
      }

      if (idMeInfo !== "") {
        const idMeInfoParsed = JSON.parse(idMeInfo);

        if (!idMeInfoParsed.Valid) {
          name = "alert-message";
        }
      }
    }

    const dialogRef = this.dialog.open(ModalWrapperComponent, {
      panelClass: "modal-panel",
      hasBackdrop: false,
      height: "100%",
      width: "100%",
    });
    dialogRef.componentInstance.modalName = name;

    dialogRef.componentInstance.Guid = this.Guid;
    dialogRef.componentInstance.CountryID = this.CountryID;
    dialogRef.componentInstance.localStrings = this.localStrings;
    dialogRef.componentInstance.AdditionalFieldsFormID = this.AdditionalFieldsFormID;
    dialogRef.componentInstance.pageConfig = this.pageConfig;
    dialogRef.componentInstance.isHotelPromotion = this.isHotelPromotion;
    dialogRef.componentInstance.promotionAlias = this.promotionAlias;

    if (name === "alert-message" && this.pageConfig.UseIdMe) {
      const idMeInfo = this.cookieService.get("idMeInfo");

      if (idMeInfo !== "") {
        const idMeInfoParsed = JSON.parse(idMeInfo);

        let message = this.localStrings[idMeInfoParsed.ErrorMessage];

        if (message == null) {
          message = idMeInfoParsed.ErrorMessage;
        }

        if (idMeInfoParsed.ErrorMessage.includes("serviceendednotfound")) {
          const redirectLink = `<a href='https://api.id.me/oauth/authorize?&scope=military,responder&client_id=1168727a565d2cca9a917a3e5ad8f624&redirect_uri=${window.location.href}&response_type=code'>here</a>`;
          message = message.replace(`<a href=''>here</a>`, redirectLink);
        }

        dialogRef.componentInstance.message = message;
      }
    }

    if (name === "find-participating-dealer") {
      dialogRef.componentInstance.openRequestInfoModal.subscribe(
        (Code: string) => {
          this.dialog.closeAll();
          const rid = this.openModal("request-info");
          rid.componentInstance.dealerCode = Code;
        }
      );
    }

    dialogRef.afterClosed().subscribe((r) => {
      document.getElementById("open-modal-button").blur();
    });

    return dialogRef;
  }
}
